import * as toastr from 'toastr';
import gql from "graphql-tag";
import {client} from "./client";
import {CreateContact} from "../../schema/createContact";
import {FetchResult, Mutation} from "../../types";

const getMutation = (patchObject: any): any => ({
    variables: {input: {contact: patchObject}},
    mutation: gql`${CreateContact}`
});


export async function createContact (contactPatchObject: {[key: string]: any}) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(contactPatchObject));
    const contact = result.data?.createContact?.contact;
    if (!contact) {
        toastr.error('Error creating contact')
        throw new Error('failed to create contact');
    } else {
        toastr.success('Created Contact ' + contact.name || '');
        await client.cache.reset();
        return contact;
    }
}
